// extracted by mini-css-extract-plugin
export default {"root":"PropertyRow_root__yVKtE","property":"PropertyRow_property__bSA7u","valueContainer":"PropertyRow_valueContainer__pZNTx","link":"PropertyRow_link__mCL1v"};